/*-----------------------------------------------------------------
- About
-----------------------------------------------------------------*/
export default {
    title        : 'درباره ما',
    content_title: 'درباره خشکبار بانمک',
};
